export default "__VITE_PUBLIC_ASSET__cb51aabd__"